/* eslint-disable */
// @ts-nocheck
// source: internal/job_event.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js');
goog.object.extend(proto, google_api_field_behavior_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.worklayer.internal.v1.JobEvent', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobEvent.Collaborator', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobEvent.EventType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobEvent.EventVisibility', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobEvent.JobResolution', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobEvent.Team', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobEvent.TriggeredBy', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListJobEventsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListJobEventsResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListJobEventsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ListJobEventsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListJobEventsRequest.displayName = 'proto.worklayer.internal.v1.ListJobEventsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListJobEventsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListJobEventsResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListJobEventsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListJobEventsResponse.displayName = 'proto.worklayer.internal.v1.ListJobEventsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobEvent.displayName = 'proto.worklayer.internal.v1.JobEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobEvent.Collaborator = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobEvent.Collaborator, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobEvent.Collaborator.displayName = 'proto.worklayer.internal.v1.JobEvent.Collaborator';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobEvent.Team = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobEvent.Team, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobEvent.Team.displayName = 'proto.worklayer.internal.v1.JobEvent.Team';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobEvent.TriggeredBy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobEvent.TriggeredBy.displayName = 'proto.worklayer.internal.v1.JobEvent.TriggeredBy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.displayName = 'proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListJobEventsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListJobEventsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListJobEventsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobEventsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orderBy: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListJobEventsRequest}
 */
proto.worklayer.internal.v1.ListJobEventsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListJobEventsRequest;
  return proto.worklayer.internal.v1.ListJobEventsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListJobEventsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListJobEventsRequest}
 */
proto.worklayer.internal.v1.ListJobEventsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderBy(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListJobEventsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListJobEventsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListJobEventsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobEventsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderBy();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ListJobEventsRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListJobEventsRequest} returns this
 */
proto.worklayer.internal.v1.ListJobEventsRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string order_by = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListJobEventsRequest.prototype.getOrderBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListJobEventsRequest} returns this
 */
proto.worklayer.internal.v1.ListJobEventsRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.worklayer.internal.v1.ListJobEventsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ListJobEventsRequest} returns this
 */
proto.worklayer.internal.v1.ListJobEventsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string page_token = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.ListJobEventsRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListJobEventsRequest} returns this
 */
proto.worklayer.internal.v1.ListJobEventsRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListJobEventsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListJobEventsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListJobEventsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListJobEventsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobEventsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobEventsList: jspb.Message.toObjectList(msg.getJobEventsList(),
    proto.worklayer.internal.v1.JobEvent.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListJobEventsResponse}
 */
proto.worklayer.internal.v1.ListJobEventsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListJobEventsResponse;
  return proto.worklayer.internal.v1.ListJobEventsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListJobEventsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListJobEventsResponse}
 */
proto.worklayer.internal.v1.ListJobEventsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.JobEvent;
      reader.readMessage(value,proto.worklayer.internal.v1.JobEvent.deserializeBinaryFromReader);
      msg.addJobEvents(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListJobEventsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListJobEventsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListJobEventsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListJobEventsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.JobEvent.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated JobEvent job_events = 1;
 * @return {!Array<!proto.worklayer.internal.v1.JobEvent>}
 */
proto.worklayer.internal.v1.ListJobEventsResponse.prototype.getJobEventsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobEvent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobEvent, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobEvent>} value
 * @return {!proto.worklayer.internal.v1.ListJobEventsResponse} returns this
*/
proto.worklayer.internal.v1.ListJobEventsResponse.prototype.setJobEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobEvent}
 */
proto.worklayer.internal.v1.ListJobEventsResponse.prototype.addJobEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.JobEvent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListJobEventsResponse} returns this
 */
proto.worklayer.internal.v1.ListJobEventsResponse.prototype.clearJobEventsList = function() {
  return this.setJobEventsList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListJobEventsResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListJobEventsResponse} returns this
 */
proto.worklayer.internal.v1.ListJobEventsResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    dateCreated: (f = msg.getDateCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    eventType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    eventVisibility: jspb.Message.getFieldWithDefault(msg, 4, 0),
    jobId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    description: jspb.Message.getFieldWithDefault(msg, 6, ""),
    reason: (f = msg.getReason()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    previousProvider: (f = msg.getPreviousProvider()) && proto.worklayer.internal.v1.JobEvent.Collaborator.toObject(includeInstance, f),
    newTeam: (f = msg.getNewTeam()) && proto.worklayer.internal.v1.JobEvent.Team.toObject(includeInstance, f),
    jobResolution: jspb.Message.getFieldWithDefault(msg, 10, 0),
    newProvider: (f = msg.getNewProvider()) && proto.worklayer.internal.v1.JobEvent.Collaborator.toObject(includeInstance, f),
    newClient: (f = msg.getNewClient()) && proto.worklayer.internal.v1.JobEvent.Collaborator.toObject(includeInstance, f),
    provider: (f = msg.getProvider()) && proto.worklayer.internal.v1.JobEvent.Collaborator.toObject(includeInstance, f),
    triggeredBy: (f = msg.getTriggeredBy()) && proto.worklayer.internal.v1.JobEvent.TriggeredBy.toObject(includeInstance, f),
    taskTitle: (f = msg.getTaskTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobEvent}
 */
proto.worklayer.internal.v1.JobEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobEvent;
  return proto.worklayer.internal.v1.JobEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobEvent}
 */
proto.worklayer.internal.v1.JobEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateCreated(value);
      break;
    case 3:
      var value = /** @type {!proto.worklayer.internal.v1.JobEvent.EventType} */ (reader.readEnum());
      msg.setEventType(value);
      break;
    case 4:
      var value = /** @type {!proto.worklayer.internal.v1.JobEvent.EventVisibility} */ (reader.readEnum());
      msg.setEventVisibility(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setReason(value);
      break;
    case 8:
      var value = new proto.worklayer.internal.v1.JobEvent.Collaborator;
      reader.readMessage(value,proto.worklayer.internal.v1.JobEvent.Collaborator.deserializeBinaryFromReader);
      msg.setPreviousProvider(value);
      break;
    case 9:
      var value = new proto.worklayer.internal.v1.JobEvent.Team;
      reader.readMessage(value,proto.worklayer.internal.v1.JobEvent.Team.deserializeBinaryFromReader);
      msg.setNewTeam(value);
      break;
    case 10:
      var value = /** @type {!proto.worklayer.internal.v1.JobEvent.JobResolution} */ (reader.readEnum());
      msg.setJobResolution(value);
      break;
    case 11:
      var value = new proto.worklayer.internal.v1.JobEvent.Collaborator;
      reader.readMessage(value,proto.worklayer.internal.v1.JobEvent.Collaborator.deserializeBinaryFromReader);
      msg.setNewProvider(value);
      break;
    case 12:
      var value = new proto.worklayer.internal.v1.JobEvent.Collaborator;
      reader.readMessage(value,proto.worklayer.internal.v1.JobEvent.Collaborator.deserializeBinaryFromReader);
      msg.setNewClient(value);
      break;
    case 13:
      var value = new proto.worklayer.internal.v1.JobEvent.Collaborator;
      reader.readMessage(value,proto.worklayer.internal.v1.JobEvent.Collaborator.deserializeBinaryFromReader);
      msg.setProvider(value);
      break;
    case 14:
      var value = new proto.worklayer.internal.v1.JobEvent.TriggeredBy;
      reader.readMessage(value,proto.worklayer.internal.v1.JobEvent.TriggeredBy.deserializeBinaryFromReader);
      msg.setTriggeredBy(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTaskTitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDateCreated();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEventType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getEventVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getReason();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPreviousProvider();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.worklayer.internal.v1.JobEvent.Collaborator.serializeBinaryToWriter
    );
  }
  f = message.getNewTeam();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.worklayer.internal.v1.JobEvent.Team.serializeBinaryToWriter
    );
  }
  f = message.getJobResolution();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getNewProvider();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.worklayer.internal.v1.JobEvent.Collaborator.serializeBinaryToWriter
    );
  }
  f = message.getNewClient();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.worklayer.internal.v1.JobEvent.Collaborator.serializeBinaryToWriter
    );
  }
  f = message.getProvider();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.worklayer.internal.v1.JobEvent.Collaborator.serializeBinaryToWriter
    );
  }
  f = message.getTriggeredBy();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.worklayer.internal.v1.JobEvent.TriggeredBy.serializeBinaryToWriter
    );
  }
  f = message.getTaskTitle();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.JobEvent.EventVisibility = {
  INTERNAL: 0,
  PUBLIC: 1
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.JobEvent.JobResolution = {
  JOB_RESOLUTION_UNSPECIFIED: 0,
  DONE: 1,
  CANCELLED: 2,
  TEST: 3
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.JobEvent.EventType = {
  EVENT_TYPE_UNSPECIFIED: 0,
  UNCLAIMED: 1,
  CLAIMED: 2,
  UPDATED: 3,
  AMENDED: 4,
  REOPENED: 5,
  TRANSFERRED: 6,
  FORFEITED: 7,
  PROVIDER_ADDED: 8,
  PROVIDER_REMOVED: 9,
  JOB_MEMBER_ADDED: 10,
  JOB_MEMBER_REMOVED: 11,
  TASK_MARKED_COMPLETE: 12,
  TASK_MARKED_INCOMPLETE: 13,
  CLOSED: 14,
  RESUMED_JOB: 15,
  PUT_ON_HOLD: 16,
  BECAME_INACTIVE: 17,
  PAYMENT_INFO_REQUESTED: 18,
  PAYMENT_INFO_PROVIDED: 19,
  PAYMENT_SUCCESSFUL: 20,
  PAYMENT_FAILED: 21,
  COUPON_ADDED: 22,
  COUPON_REMOVED: 23,
  REFUND_SUCCESSFUL: 24,
  REFUND_FAILED: 25,
  MANUAL_INVOICE_ADDED: 26,
  ANSWERS_CORRECTED: 27,
  INFO_GATHERING_COMPLETED: 28,
  CLIENT_ADDED: 29,
  BECAME_ACTIVE: 30
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobEvent.Collaborator.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobEvent.Collaborator.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobEvent.Collaborator} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobEvent.Collaborator.toObject = function(includeInstance, msg) {
  var f, obj = {
    displayName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobEvent.Collaborator}
 */
proto.worklayer.internal.v1.JobEvent.Collaborator.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobEvent.Collaborator;
  return proto.worklayer.internal.v1.JobEvent.Collaborator.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobEvent.Collaborator} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobEvent.Collaborator}
 */
proto.worklayer.internal.v1.JobEvent.Collaborator.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobEvent.Collaborator.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobEvent.Collaborator.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobEvent.Collaborator} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobEvent.Collaborator.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string display_name = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobEvent.Collaborator.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobEvent.Collaborator} returns this
 */
proto.worklayer.internal.v1.JobEvent.Collaborator.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobEvent.Team.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobEvent.Team.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobEvent.Team} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobEvent.Team.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobEvent.Team}
 */
proto.worklayer.internal.v1.JobEvent.Team.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobEvent.Team;
  return proto.worklayer.internal.v1.JobEvent.Team.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobEvent.Team} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobEvent.Team}
 */
proto.worklayer.internal.v1.JobEvent.Team.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobEvent.Team.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobEvent.Team.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobEvent.Team} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobEvent.Team.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobEvent.Team.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobEvent.Team} returns this
 */
proto.worklayer.internal.v1.JobEvent.Team.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobEvent.TriggeredBy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobEvent.TriggeredBy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userPublicId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    givenName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    familyName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    email: (f = msg.getEmail()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    picture: (f = msg.getPicture()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobEvent.TriggeredBy}
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobEvent.TriggeredBy;
  return proto.worklayer.internal.v1.JobEvent.TriggeredBy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobEvent.TriggeredBy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobEvent.TriggeredBy}
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPublicId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGivenName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamilyName(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmail(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPicture(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobEvent.TriggeredBy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobEvent.TriggeredBy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGivenName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFamilyName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEmail();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPicture();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobEvent.TriggeredBy} returns this
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_public_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.getUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobEvent.TriggeredBy} returns this
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.setUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string given_name = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.getGivenName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobEvent.TriggeredBy} returns this
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.setGivenName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string family_name = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.getFamilyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobEvent.TriggeredBy} returns this
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.setFamilyName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue email = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.getEmail = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.JobEvent.TriggeredBy} returns this
*/
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.setEmail = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobEvent.TriggeredBy} returns this
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.clearEmail = function() {
  return this.setEmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue picture = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.getPicture = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.JobEvent.TriggeredBy} returns this
*/
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.setPicture = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobEvent.TriggeredBy} returns this
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.clearPicture = function() {
  return this.setPicture(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobEvent.TriggeredBy.prototype.hasPicture = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp date_created = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getDateCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
*/
proto.worklayer.internal.v1.JobEvent.prototype.setDateCreated = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.clearDateCreated = function() {
  return this.setDateCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobEvent.prototype.hasDateCreated = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional EventType event_type = 3;
 * @return {!proto.worklayer.internal.v1.JobEvent.EventType}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getEventType = function() {
  return /** @type {!proto.worklayer.internal.v1.JobEvent.EventType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobEvent.EventType} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.setEventType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional EventVisibility event_visibility = 4;
 * @return {!proto.worklayer.internal.v1.JobEvent.EventVisibility}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getEventVisibility = function() {
  return /** @type {!proto.worklayer.internal.v1.JobEvent.EventVisibility} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobEvent.EventVisibility} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.setEventVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string job_id = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.protobuf.StringValue reason = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getReason = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
*/
proto.worklayer.internal.v1.JobEvent.prototype.setReason = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.clearReason = function() {
  return this.setReason(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobEvent.prototype.hasReason = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Collaborator previous_provider = 8;
 * @return {?proto.worklayer.internal.v1.JobEvent.Collaborator}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getPreviousProvider = function() {
  return /** @type{?proto.worklayer.internal.v1.JobEvent.Collaborator} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.JobEvent.Collaborator, 8));
};


/**
 * @param {?proto.worklayer.internal.v1.JobEvent.Collaborator|undefined} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
*/
proto.worklayer.internal.v1.JobEvent.prototype.setPreviousProvider = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.clearPreviousProvider = function() {
  return this.setPreviousProvider(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobEvent.prototype.hasPreviousProvider = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Team new_team = 9;
 * @return {?proto.worklayer.internal.v1.JobEvent.Team}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getNewTeam = function() {
  return /** @type{?proto.worklayer.internal.v1.JobEvent.Team} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.JobEvent.Team, 9));
};


/**
 * @param {?proto.worklayer.internal.v1.JobEvent.Team|undefined} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
*/
proto.worklayer.internal.v1.JobEvent.prototype.setNewTeam = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.clearNewTeam = function() {
  return this.setNewTeam(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobEvent.prototype.hasNewTeam = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional JobResolution job_resolution = 10;
 * @return {!proto.worklayer.internal.v1.JobEvent.JobResolution}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getJobResolution = function() {
  return /** @type {!proto.worklayer.internal.v1.JobEvent.JobResolution} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobEvent.JobResolution} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.setJobResolution = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional Collaborator new_provider = 11;
 * @return {?proto.worklayer.internal.v1.JobEvent.Collaborator}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getNewProvider = function() {
  return /** @type{?proto.worklayer.internal.v1.JobEvent.Collaborator} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.JobEvent.Collaborator, 11));
};


/**
 * @param {?proto.worklayer.internal.v1.JobEvent.Collaborator|undefined} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
*/
proto.worklayer.internal.v1.JobEvent.prototype.setNewProvider = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.clearNewProvider = function() {
  return this.setNewProvider(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobEvent.prototype.hasNewProvider = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional Collaborator new_client = 12;
 * @return {?proto.worklayer.internal.v1.JobEvent.Collaborator}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getNewClient = function() {
  return /** @type{?proto.worklayer.internal.v1.JobEvent.Collaborator} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.JobEvent.Collaborator, 12));
};


/**
 * @param {?proto.worklayer.internal.v1.JobEvent.Collaborator|undefined} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
*/
proto.worklayer.internal.v1.JobEvent.prototype.setNewClient = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.clearNewClient = function() {
  return this.setNewClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobEvent.prototype.hasNewClient = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional Collaborator provider = 13;
 * @return {?proto.worklayer.internal.v1.JobEvent.Collaborator}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getProvider = function() {
  return /** @type{?proto.worklayer.internal.v1.JobEvent.Collaborator} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.JobEvent.Collaborator, 13));
};


/**
 * @param {?proto.worklayer.internal.v1.JobEvent.Collaborator|undefined} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
*/
proto.worklayer.internal.v1.JobEvent.prototype.setProvider = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.clearProvider = function() {
  return this.setProvider(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobEvent.prototype.hasProvider = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional TriggeredBy triggered_by = 14;
 * @return {?proto.worklayer.internal.v1.JobEvent.TriggeredBy}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getTriggeredBy = function() {
  return /** @type{?proto.worklayer.internal.v1.JobEvent.TriggeredBy} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.JobEvent.TriggeredBy, 14));
};


/**
 * @param {?proto.worklayer.internal.v1.JobEvent.TriggeredBy|undefined} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
*/
proto.worklayer.internal.v1.JobEvent.prototype.setTriggeredBy = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.clearTriggeredBy = function() {
  return this.setTriggeredBy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobEvent.prototype.hasTriggeredBy = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue task_title = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.JobEvent.prototype.getTaskTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
*/
proto.worklayer.internal.v1.JobEvent.prototype.setTaskTitle = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobEvent} returns this
 */
proto.worklayer.internal.v1.JobEvent.prototype.clearTaskTitle = function() {
  return this.setTaskTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobEvent.prototype.hasTaskTitle = function() {
  return jspb.Message.getField(this, 15) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobEvent: (f = msg.getJobEvent()) && proto.worklayer.internal.v1.JobEvent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent}
 */
proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent;
  return proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent}
 */
proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.JobEvent;
      reader.readMessage(value,proto.worklayer.internal.v1.JobEvent.deserializeBinaryFromReader);
      msg.setJobEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobEvent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.JobEvent.serializeBinaryToWriter
    );
  }
};


/**
 * optional JobEvent job_event = 1;
 * @return {?proto.worklayer.internal.v1.JobEvent}
 */
proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.prototype.getJobEvent = function() {
  return /** @type{?proto.worklayer.internal.v1.JobEvent} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.JobEvent, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.JobEvent|undefined} value
 * @return {!proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent} returns this
*/
proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.prototype.setJobEvent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.prototype.clearJobEvent = function() {
  return this.setJobEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobEventRecordedRealtimeEvent.prototype.hasJobEvent = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.worklayer.internal.v1);
